import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Input from './Input';
import Tooltip from '../../Tooltip';
import './Input.scss';

function PriceInput(props) {
  const {
    disabled,
    applyDisabledStyleToDollarSign,
    required,
    onChange,
    className,
    placeholder,
    onFocus,
    onBlur,
    tooltip,
    displayDollarSign,
    isInputModeDecimal,
  } = props;
  const value = props.value === 0 ? '' : props.value;
  const input = (
    <Input
      disabled={disabled}
      required={required}
      onChange={onChange}
      value={value}
      className={className}
      type="number"
      placeholder={placeholder}
      onFocus={onFocus}
      onBlur={onBlur}
      step={props.step}
      onKeyDown={props.onKeyDown}
      {...(isInputModeDecimal && { inputMode: 'decimal' })}
      data-testid={props['data-testid']}
    />
  );
  return (
    <div className="finance-input">
      {displayDollarSign && (
        <span
          className={classnames({
            'disabled-sign': disabled && applyDisabledStyleToDollarSign,
          })}
        >
          $
        </span>
      )}
      {tooltip ? <Tooltip text={tooltip}>{input}</Tooltip> : input}
    </div>
  );
}

PriceInput.defaultProps = {
  placeholder: '0',
  step: 'any',
  applyDisabledStyleToDollarSign: true,
  displayDollarSign: true,
  isInputModeDecimal: false,
};

PriceInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  applyDisabledStyleToDollarSign: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.any,
  step: PropTypes.any,
  tooltip: PropTypes.string,
  displayDollarSign: PropTypes.bool,
  onKeyDown: PropTypes.func,
  isInputModeDecimal: PropTypes.bool,
};

export default PriceInput;
